import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';
import DataSet from './DataSet';

// Todo: can be removed/refactored in the future if we have data contract parser for all visualizations
// Some functions are still used by Gauges, we can remove them when gauges have been refreshed.
/**
 * Returns a dataset instance based on data from props
 * @param {object} vizProps
 * @param {string} [dataSourceType='primary']
 * @returns {DataSet}
 */
export function getDataSet(vizProps, dataSourceType = 'primary') {
    const data = get(vizProps, ['dataSources', dataSourceType, 'data']);
    return data ? new DataSet(data.fields, data.columns) : null;
}

/**
 * Returns the request parameters for a dataSourceType in vizProps
 * @param {object} dataSourcesProps
 * @param {string} [dataSourceType='primary']
 * @returns {object}
 */
export function getRequestParams(vizProps, dataSourceType = 'primary') {
    return get(vizProps, ['dataSources', dataSourceType, 'requestParams']);
}

/**
 * Returns the meta data for a dataSourceType in vizProps
 * @param {object} vizProps
 * @param {string} [dataSourceType='primary']
 * @returns {object}
 */
export function getMeta(vizProps, dataSourceType = 'primary') {
    return get(vizProps, ['dataSources', dataSourceType, 'meta'], {});
}

/**
 * Returns the annotation label and color as arrays
 * If annotation.categoryColors is defined with labels, as an object in options, such as {"Server Stop":"#FF0000","Server Start":"00FF00"},
 * parse annotation color and labels from options, otherwise from encoding.
 * @param {Object} input
 * @param {(Object|String)} input.annotationCategoryColor  annotation.categoryColors option
 * @param {Array} input.annotationLabelEncoding
 * @param {Array} input.annotationColorEncoding
 * @returns {Object} annotation
 * @returns {Array} annotation.annotationLabel
 * @returns {Array} annotation.annotationColor
 */
export function getAnnotationLabelAndColor({
    annotationCategoryColor,
    annotationLabelEncoding,
    annotationColorEncoding,
}) {
    if (!isPlainObject(annotationCategoryColor) && typeof annotationCategoryColor !== 'string') {
        return {
            annotationLabel: annotationLabelEncoding,
            annotationColor: annotationColorEncoding,
        };
    }

    let annotationObj = annotationCategoryColor;

    if (typeof annotationCategoryColor === 'string') {
        // eslint-disable-next-line no-console
        console.warn(`The option type 'string' for 'annotation.categoryColors' has been deprecated.`);
        try {
            annotationObj = JSON.parse(annotationCategoryColor);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn(`'annotation.categoryColors' option is not a valid JSON string.`);
            return {
                annotationLabel: annotationLabelEncoding,
                annotationColor: annotationColorEncoding,
            };
        }
    }

    // If no annotationLabel is defined in encoding, generate a sequence of annotationLabel from the keys of annotation.categoryColor option.
    const annotationLabel =
        annotationLabelEncoding && Array.isArray(annotationLabelEncoding)
            ? annotationLabelEncoding
            : Object.keys(annotationObj);

    // If annotationColor encoding and annotation.categoryColors option are both defined, take the colors defined in color option,
    // and the remaining colors from the encoding if they are not defined in option.
    // Or if annotationColor encoding is not defined, use annotation.categoryColors option to generate a color array.
    let annotationColor;
    if (annotationColorEncoding && Array.isArray(annotationColorEncoding)) {
        annotationColor = [...annotationColorEncoding];
        annotationLabel.forEach((label, i) => {
            if (annotationObj[label]) {
                annotationColor[i] = annotationObj[label];
            }
        });
    } else {
        annotationColor = annotationLabel.map(label => annotationObj[label]);
    }

    return {
        annotationLabel,
        annotationColor,
    };
}
